import React from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
import { useMount } from "@sportal/cdk/hooks";

import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { Icon } from "../../../../components/icon/Icon";
import { load } from "./webFilters.actions";
import { WebFiltersComponentMobile } from "./WebFiltersComponentMobile";
import { WebFiltersComponentDesktop } from "./WebFiltersComponentDesktop";

import "./WebFilters.scss";

export interface WebFiltersProps {
  className: string;
  profileId: string;
}

export const WebFilters = ({ className, profileId }: WebFiltersProps) => {
  const dispatch = useDispatch();

  useMount(() => dispatch(load()));

  return (
    <div className={classnames("web-filters", className)}>
      <h2 className="web-filters__header">
        <Icon icon="fa-solid fa-shield-alt" />
        <span>
          <FormattedMessage id={"web_filters"} />
        </span>
      </h2>
      <Mobile>
        <WebFiltersComponentMobile profileId={profileId} />
      </Mobile>
      <NotMobile>
        <WebFiltersComponentDesktop profileId={profileId} />
      </NotMobile>
    </div>
  );
};
